export * from './avatar-list-with-tag-component-config.interface';
